import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function useTheme() {
  const [dark, setDark] = useState(() => localStorage.getItem("tendly-theme") === "dark");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("tendly-theme", dark ? "dark" : "light");
  }, [dark]);
  return [dark, setDark];
}

export default function ThemeToggle({ dark, onToggle }) {
  return (
    <button
      data-testid="theme-toggle"
      onClick={() => onToggle(!dark)}
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      className="p-2 rounded-full border border-border bg-card hover:bg-secondary transition-colors"
    >
      {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
